import type { IPasserService } from '@/domain/precon-supporter/services';
import type { PasserRequest } from '@/domain/precon-supporter/types/passer';
import { PreconSupporterApiClient } from '../../api/precon-supporter-api-client';

export class PasserService implements IPasserService {
  constructor(private apiClient: PreconSupporterApiClient) {}

  async createPasser(
    request: PasserRequest,
    passerToken: string
  ): Promise<void> {
    try {
      const payload = {
        gender: request.gender,
        birthyear: request.birthyear,
        job: request.job,
        prefecture: request.prefecture,
        course_id: request.courseId,
        ...(request.jobType ? { job_type: request.jobType } : {}),
      } as Record<string, unknown>;

      await this.apiClient.createPasser(payload, passerToken);
      return;
    } catch (error) {
      const message =
        error instanceof Error ? error.message : '未知のエラーが発生しました';
      throw new Error(`${message}`);
    }
  }
}
